import { API_BASE } from './client.js'
import type { PublicOrganization, PublicLocation, PublicMenu, PublicCategory, PublicProduct, PublicSchedule, PublicCity } from '../../shared/api/public-types.js'

async function publicFetch<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`)
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: { message: `Request failed (${res.status})` } }))
    throw new Error(body?.error?.message ?? `Request failed (${res.status})`)
  }
  const json = await res.json()
  return json.data as T
}

export function getPublicCity(citySlug: string): Promise<PublicCity> {
  return publicFetch<PublicCity>(`/public/cities/${encodeURIComponent(citySlug)}`)
}

export function getPublicOrganization(orgSlug: string): Promise<PublicOrganization> {
  return publicFetch<PublicOrganization>(`/public/organizations/${encodeURIComponent(orgSlug)}`)
}

export function getPublicLocations(orgSlug: string): Promise<PublicLocation[]> {
  return publicFetch<PublicLocation[]>(`/public/organizations/${encodeURIComponent(orgSlug)}/locations`)
}

export function getPublicSchedule(orgSlug: string, locationSlug: string): Promise<PublicSchedule> {
  return publicFetch<PublicSchedule>(
    `/public/${encodeURIComponent(orgSlug)}/locations/${encodeURIComponent(locationSlug)}/schedule`,
  )
}

export function getPublicMenus(orgSlug: string, locationSlug: string): Promise<PublicMenu[]> {
  return publicFetch<PublicMenu[]>(
    `/public/organizations/${encodeURIComponent(orgSlug)}/locations/${encodeURIComponent(locationSlug)}/menus`,
  )
}

export function getPublicCategories(
  orgSlug: string, locationSlug: string, menuId: string,
): Promise<PublicCategory[]> {
  return publicFetch<PublicCategory[]>(
    `/public/organizations/${encodeURIComponent(orgSlug)}/locations/${encodeURIComponent(locationSlug)}/menus/${menuId}/categories`,
  )
}

export function getPublicProducts(
  orgSlug: string, locationSlug: string, menuId: string,
): Promise<PublicProduct[]> {
  return publicFetch<PublicProduct[]>(
    `/public/organizations/${encodeURIComponent(orgSlug)}/locations/${encodeURIComponent(locationSlug)}/menus/${menuId}/products`,
  )
}